const { Netmask } = require('netmask');

// Browser-compatible IPv4 format validation
function isV4Format(ipStr) {
    const ipv4Regex = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
    return ipv4Regex.test(ipStr);
}

function ipToLong(ipStr) {
    // Convert IPv4 address to 32-bit integer
    return ipStr.split('.').reduce((acc, octet) => (acc << 8) + parseInt(octet), 0);
}

exports.matchIPv4 = (ipAddress, policyList) => {
    // Validate IPv4 format
    if (!isV4Format(ipAddress)) {
        return false;
    }

    const ipLong = ipToLong(ipAddress);
    // Flatten and trim policies
    const policies = policyList.flatMap(entry => entry.split(',').map(p => p.trim()));

    return policies.some(policy => {
        if (policy.includes('-')) {
            // IP Range
            const [startIP, endIP] = policy.split('-').map(p => p.trim());
            if (isV4Format(startIP) && isV4Format(endIP)) {
                return ipLong >= ipToLong(startIP) && ipLong <= ipToLong(endIP);
            }
        } else if (policy.includes('/')) {
            // CIDR
            try {
                return new Netmask(policy).contains(ipAddress);
            } catch {
                return false;
            }
        } else if (policy.includes('*')) {
            // Wildcard
            const parts = policy.split('.');
            if (parts.length !== 4 || !parts.every(p => p === '*' || /^\d+$/.test(p))) {
                return false;
            }
            // Create regex for wildcard policy, matching valid octets (0–255)
            const regex = new RegExp('^' + policy.replace(/\./g, '\\.').replace(/\*/g, '([0-1]?\\d{1,2}|2[0-4]\\d|25[0-5])') + '$');
            return regex.test(ipAddress);
        } else if (isV4Format(policy)) {
            // Exact IP
            return ipAddress === policy;
        }
        return false;
    });
}